export default __webpack_public_path__ + "static/media/multichannel-task.3ce9b21c.svg";